import { createSlice } from "@reduxjs/toolkit";
import Utils from "../utility";
import { keyConstants } from "../constants";
import history from "../managers/history";
const { USER, TOKEN, FIRST_TIME_LOGGED_IN } = keyConstants;

const user = Utils.localStorageGetItem(USER);
const isFirstTimeLoggedIn = Utils.localStorageGetItem(FIRST_TIME_LOGGED_IN);
const userData = user ? user : {};

const initialState = {
  userId: userData?.userId,
  name: userData?.name,
  lastName: userData?.name,
  email: userData?.email,
  logo: userData?.logo,
  isEmailVerified: userData?.isEmailVerified,
  isLoggedIn: !!userData?.userId,
  _id: userData._id,
  loginThrough: userData?.loginThrough,
  loading: false,
  emailMarketingId: userData?.emailMarketingId || "",
  isFirstTimeLoggedIn: isFirstTimeLoggedIn || false,
  isMobileSidebar: false,
  password: userData?.password || null
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    /**
     * Updates the user state with the provided action payload.
     *
     * @param {Object} state - The current state of the user.
     * @param {Object} action - The action object containing the payload.
     * @return {Object} The updated state with the payload applied.
     */
    updateUser: (state, action) => {
      Utils.localStorageSetItem(USER, action.payload);
      return {
        ...state,
        ...action.payload
      };
    },
    /**
     * Removes a user from the state and performs additional cleanup tasks.
     *
     * @param {object} state - The current state object.
     * @param {object} action - The action object containing additional information.
     * @returns {object} The updated state object with the user removed.
     */
    removeUser: (state, action) => {
      history.push("/");
      Utils.localStorageClear();
      Utils.cookieClearItem(TOKEN);
      action.payload = Object.fromEntries(
        Object.keys(state || {}).map((key) => [key, ""])
      );
      action.payload.isLoggedIn = false;
      return {
        ...state,
        ...action.payload
      };
    },
    showLoader: (state) => {
      return {
        ...state,
        loading: true
      };
    },
    hideLoader: (state) => {
      return {
        ...state,
        loading: false
      };
    },
    firstTimeLoggedIn: (state, action) => {
      Utils.localStorageSetItem(FIRST_TIME_LOGGED_IN, action.payload);
      return {
        ...state,
        isFirstTimeLoggedIn: action.payload
      };
    },

    mobileSideBar: (state, action) => {
      return {
        ...state,
        isMobileSidebar: action.payload
      };
    }
  }
});

export const {
  updateUser,
  removeUser,
  showLoader,
  hideLoader,
  firstTimeLoggedIn,
  mobileSideBar
} = userSlice.actions;

export default userSlice.reducer;
